// extracted by mini-css-extract-plugin
module.exports = {"button":"facebookButton_button__dwNxc","buttonLogo":"facebookButton_buttonLogo__3ZUl9"};